<template>
  <ThemeDefaultContainerSection
    :title="modelValue.title"
    title-underline
    :description="modelValue.description"
  >
    <!-- Video Section -->
    <div
      :class="[
        'tw-mt-8 lg:tw-mt-12',
        modelValue.content.length === 1
          ? 'tw-flex tw-justify-center'
          : 'tw-grid tw-gap-5 lg:tw-grid-cols-12',
      ]"
    >
      <!-- Main Video -->
      <div
        :class="modelValue.content.length === 1 ? 'tw-w-full lg:tw-w-7/12 tw-min-w-0' : 'lg:tw-col-span-6 tw-min-w-0'"
      >
        <div
          v-if="modelValue.content.length >= 1"
          class="tw-overflow-hidden"
        >
          <ThemeDefaultCardVideo
            title-tag="h3"
            :youtube-url="modelValue.content[0]?.youtubeUrl ?? ''"
            :title="modelValue.content[0]?.title ?? ''"
            :description="modelValue.content[0]?.description ?? ''"
            :video-category="modelValue.content[0]?.videoCategory"
            is-main-card
            custom-video-title-class="!tw-line-clamp-1"
            @click="eventHomeVideo(modelValue.content[0]?.title ?? '')"
          />
        </div>
      </div>

      <!-- Additional Videos -->
      <div
        v-if="modelValue.content.length >= 2"
        class="lg:tw-col-span-6 tw-min-w-0"
      >
        <div
          v-for="item in modelValue.content.slice(1, 4)"
          :key="`video-card-one-${item._id}`"
          class="tw-overflow-hidden tw-mb-5"
        >
          <ThemeDefaultCardVideo
            :youtube-url="item.youtubeUrl"
            :title="item.title"
            :description="item.description"
            :video-category="item.videoCategory"
            :horizontal="modelValue.content.length > 2"
            @click="eventHomeVideo(item.title)"
          />
        </div>
      </div>
    </div>
  </ThemeDefaultContainerSection>
</template>

<script setup lang="ts">
// Props
const props = defineProps({
  modelValue: {
    type: Object as () => HomeSection<VideoMeta[]>,
    required: true,
  },
})
const { eventHomeVideo } = useVideoSection()
</script>
